import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

const basename = import.meta.env.BASE_URL || '/';
import { useStore } from './store';
import { trackRouteView } from './analytics';

// Onboarding screens
import {
  RatingTypeScreen,
  GenderScreen,
  AgeScreen,
  FocusAreasScreen,
  SelfRatingScreen,
  MissionScreen,
  ImproveMoreScreen,
  AppearanceAnxietyScreen,
  MotivationScreen,
  ScienceScreen,
  ComplimentsScreen,
  Week1Screen,
  Week10Screen,
  ComparisonScreen,
  TrajectoryScreen,
  LockInScreen,
  HypeScreen,
} from './screens/onboarding';

// Rating screens
import {
  FrontPhotoScreen,
  SidePhotoScreen,
  AnalyzingScreen,
} from './screens/rating';

// Other screens
import { PaywallScreen } from './screens/PaywallScreen';
import { ResultsScreen } from './screens/ResultsScreen';
import { ResultsHistoryScreen } from './screens/ResultsHistoryScreen';

function ScreenTracker() {
  const location = useLocation();

  useEffect(() => {
    trackRouteView(location.pathname);
  }, [location.pathname]);

  return null;
}

function App() {
  const { initializeUser } = useStore();

  // Initialize user ID on app load
  useEffect(() => {
    initializeUser();
  }, [initializeUser]);

  return (
    <BrowserRouter basename={basename}>
      <ScreenTracker />
      <Routes>
        {/* Redirect root to onboarding */}
        <Route path="/" element={<Navigate to="/onboarding/rating-type" replace />} />

        {/* Onboarding flow */}
        <Route path="/onboarding/rating-type" element={<RatingTypeScreen />} />
        <Route path="/onboarding/gender" element={<GenderScreen />} />
        <Route path="/onboarding/age" element={<AgeScreen />} />
        <Route path="/onboarding/focus" element={<FocusAreasScreen />} />
        <Route path="/onboarding/self-rating" element={<SelfRatingScreen />} />
        <Route path="/onboarding/mission" element={<MissionScreen />} />
        <Route path="/onboarding/improve-more" element={<ImproveMoreScreen />} />
        <Route path="/onboarding/appearance-anxiety" element={<AppearanceAnxietyScreen />} />
        <Route path="/onboarding/motivation" element={<MotivationScreen />} />
        <Route path="/onboarding/science" element={<ScienceScreen />} />
        <Route path="/onboarding/compliments" element={<ComplimentsScreen />} />
        <Route path="/onboarding/week1" element={<Week1Screen />} />
        <Route path="/onboarding/week10" element={<Week10Screen />} />
        <Route path="/onboarding/comparison" element={<ComparisonScreen />} />
        <Route path="/onboarding/trajectory" element={<TrajectoryScreen />} />
        <Route path="/onboarding/lockin" element={<LockInScreen />} />
        <Route path="/onboarding/hype" element={<HypeScreen />} />

        {/* Rating flow (requires login) */}
        <Route path="/rating/front" element={<FrontPhotoScreen />} />
        <Route path="/rating/side" element={<SidePhotoScreen />} />
        <Route path="/rating/analyzing" element={<AnalyzingScreen />} />

        {/* Paywall */}
        <Route path="/paywall" element={<PaywallScreen />} />

        {/* Results */}
        <Route path="/results/history" element={<ResultsHistoryScreen />} />
        <Route path="/results/view" element={<ResultsScreen />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/onboarding/rating-type" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
